const menuItems = (items) => {
  return items.map((item) => {
    return {
      id: item.id,
      name: item.title,
      url: item.url,
      target: item.target === 'blank' ? '_blank' : '_self',
      submenu:
        Array.isArray(item.items) && item.items.length
          ? menuItems(item.items)
          : null,
    };
  });
};

export const menuAdapter = (data) => {
  return menuItems(data.data);
};
